import Add16 from '@carbon/icons-react/es/add/16';
import { faFileInvoiceDollar } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { PermissionsContext } from 'contexts/permissions';

interface Props {
  primaryCta: () => void;
}

export const RateCardsEmptyState: FC<Props> = ({ primaryCta }) => {
  const { canCreate } = useContext(PermissionsContext);

  return (
    <EmptyStateContainer $transparent>
      <EmptyState
        image={<EmptyStateIcon icon={faFileInvoiceDollar} size="5x" />}
        title={<FormattedMessage id="settings.rate_cards.empty_state.title" />}
        message={
          <FormattedMessage id="settings.rate_cards.empty_state.content" />
        }
        primaryCTA={
          canCreate && (
            <Button
              type="primary"
              onClick={primaryCta}
              iconPlacement="right"
              icon={<Add16 />}
            >
              <FormattedMessage id="settings.rate_cards.new_card.cta" />
            </Button>
          )
        }
      />
    </EmptyStateContainer>
  );
};
